import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import SalaryClassMiddleware from "../../../../middleware/modules/hr/salary-class";
import Form from "../../../../components/modules/hr/salary-class/form";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import { View } from "../../../../components/modules/hr/salary-class/view";

const mapStateToProps = ({ auth, salaryClass}) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: salaryClass.isProcessing,
  isError: salaryClass.isError,
  errorMessage: salaryClass.errorMessage,
  dataUpdate: salaryClass.single,
  type:salaryClass.typeModal,
  isSuccess: salaryClass.isSuccess,
  isReset: salaryClass.isReset,
  isNewRecord: salaryClass.isNewRecord,
  onSubmit: salaryClass.onSubmit,
  helperList:salaryClass.helperSalaryClass
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => SalaryClassMiddleware.reset(),
      new: (data, search) => SalaryClassMiddleware.beforeSaveNew(data, search),
      update: (id, type, search) =>
      SalaryClassMiddleware.beforeSaveUpdate(id, type, search),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
    salaryCutsList:PropTypes.array,
    allowanceList:PropTypes.array,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
    salaryCutsList:[],
    allowanceList:[],
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  getData() {
    return this.props.showOne(this.props.dataID);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if (isNewRecord) {
      this.props.new(form, search);
    } else {
      this.props.update(dataUpdate.id, form, search);
    }
  }

  render() {
    const {
      onSubmit,
      showModal,
      titleModal,
      type
    } = this.props;
    return (
      <>
        <Modal show={showModal} size={"md"}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            {(type=="view")?
            <View {...this.props}
            >
            </View>: <Form
             {...this.props}
              ref={this.form}
            />}
           
          </Modal.Body>
          {(type=="update")?
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>:
          <Modal.Footer className={"justify-content-center"}>
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
          </Modal.Footer>}
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
